/**
* Index.ts
* @author Ram Thiru (ramthi) and Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* File to export the JSLL Wrapper object and interfaces.
*/
import { getGlobal } from "@microsoft/applicationinsights-core-js";
import { JavascriptLoggingLibrary } from "./Jsll";
export { JavascriptLoggingLibrary };
// Global instance
getGlobal()["awa"] = new JavascriptLoggingLibrary();
//# sourceMappingURL=Index.js.map